import { IBaoCaoThongKeActionTypes } from "../../action-types/bao-cao-thong-ke/IBaoCaoThongKeActions";
import { IBaoCaoThongKeReducer } from "../../reducer-model/bao-cao-thong-ke/IBaoCaoThongKeReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IBaoCaoThongKeReducer = {
    status: eReducerStatusBase.is_not_initialization,
    selectedMenu: "",
};

export const baoCaoThongKeReducer = (state = iniState, action: IBaoCaoThongKeActionTypes): IBaoCaoThongKeReducer => {
    switch (action.type) {
        case "BAO_CAO_THONG_KE_SELECTED_MENU":
            return {
                ...state,
                selectedMenu: action.payload,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};